export default __webpack_public_path__ + "static/media/logokitchen.8bc5df9a.gif";